// extracted by mini-css-extract-plugin
module.exports = {"ratingItem":"CompanyRatings_ratingItem__2oO1-","circlesWrapper":"CompanyRatings_circlesWrapper__21Vs4","noResults":"CompanyRatings_noResults__37xip"};